export const sortingCriteria = [
    {text: "Numero di telefono", value: "msisdn"}
]